import { Button, DialogActions, DialogContent, DialogContentText, TextField, Typography } from '@mui/material';
import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { ReactComponent as IconCTH } from 'assets/icons/IconCTH.svg';
import { ReactComponent as IconInfoEl } from 'assets/icons/IconInfoEl.svg';
import { ReactComponent as IconKeyboard } from 'assets/icons/IconKeyboard.svg';
import { TooltipCC } from 'components/common';
import { NS_TRANS } from 'constants/common';
import useMeetingCC from 'hooks/useMeetingCC';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import theme from 'theme';
import { setCloseDialogCC } from 'utils/helpers';
import { FUNCTIONS } from 'constants/roles';
import { checkFunctionHaveCode } from 'store/user/functions';
import { selectCurrentUserFunctions } from 'store/selectors';
import DialogBaseCC from './DialogBaseCC';
import { DIALOG_ID } from './constant';
import { validateRoomId } from 'utils/validates';

const popoverInfoC = {
    cth: {
        title: 'popover.titleCTH',
        content: 'popover.contentCTH',
        info: 'popover.infoCTH',
        placeholder: 'popover.placeholderCTH',
        btnTitle: 'popover.btnJoinCTH',
        btnOpen: 'manageMeeting:mnMeeting.cth',
        btnOpenIcon: <IconCTH />
    },
    meet: {
        title: 'popover.titleMeet',
        content: 'popover.contentMeet',
        info: 'popover.infoMeet',
        placeholder: 'popover.placeholderMeet',
        btnTitle: 'popover.btnJoinMeet',
        btnOpen: 'manageMeeting:mnMeeting.joinId',
        btnOpenIcon: <IconKeyboard />
    }
}

const SIP_ERROR_CODES = [
    'SIP_USER_REQUIRED',
    'SIP_USER_INVALID',
    'SIP_CALL_NOT_ALLOWED',
    'SIP_ACCOUNT_NOT_ASSIGNED',
    'SIP_CALLED_ROOM_DISABLED',
    'CONCURRENT_MEETING_LIMIT_REACHED',
    'INSTANT_MEETING_REQUIRES_APPROVAL',
    'POPUP_BLOCKED',
    'CALLED_ROOM_REQUEST_FAILED'
]

const MeetingDialogForm = ({ type, t, open }) => {
    const { handleJoinID, isJoining, joinError, clearJoinError } = useMeetingCC()
    const [roomId, setRoomId] = useState('')

    useEffect(() => {
        if (open) {
            setRoomId('')
            clearJoinError()
        }
    }, [open, clearJoinError])

    const isValid = validateRoomId(roomId, type)
    const errorCode = SIP_ERROR_CODES.includes(joinError) ? joinError : 'CALLED_ROOM_REQUEST_FAILED'
    const handleChangeRoomID = e => {
        setRoomId(e.target.value)
        clearJoinError()
    }
    const handleJoin = async() => {
        if (!isValid || isJoining) return
        const succeeded = await handleJoinID(type, roomId, undefined)
        if (succeeded) setRoomId('')
    }

    return (
        <>
            <DialogContent>
                <DialogContentText>
                    {t(popoverInfoC[type].content)} <TooltipCC placement="bottom-start" title={t(popoverInfoC[type].info)}>
                        <IconInfoEl style={{ cursor: 'pointer' }}/>
                    </TooltipCC>
                    <TextField autoFocus fullWidth placeholder={t(popoverInfoC[type].placeholder)} value={roomId} onChange={handleChangeRoomID} sx={{ marginTop: theme.spacing(2.5) }} onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault()
                            handleJoin()
                        }
                    }}/>
                    {joinError && <Typography role="alert">{t(`${NS_TRANS.MANAGE_MEETING}:sipCalledRoom.errors.${errorCode}`)}</Typography>}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={setCloseDialogCC}>{t('dialog.cancel', { ns: NS_TRANS.MAIN})}</Button>
                <Button aria-busy={isJoining} disabled={!isValid || isJoining} onClick={handleJoin} >{t(popoverInfoC[type].btnTitle)}</Button>
            </DialogActions>
        </>
    )
}

const DialogJoinMeetingCC = () => {
    const {t} = useTranslation([NS_TRANS.MANAGE_MEETING])
    const propsDialog = useLegacyDialogProps()
    const open = useSelector((state) => state.dialog.open)
    const functions = useSelector(selectCurrentUserFunctions)
    const { type = 'meet' } = propsDialog
    const canCallSip = type !== 'cth' || checkFunctionHaveCode(functions, FUNCTIONS.MANAGE_CALL_SIP)

    return (
        <DialogBaseCC id={DIALOG_ID.JOIN_MEETING} title={t(popoverInfoC[type].title)}>
            {canCallSip ? <MeetingDialogForm type={type} t={t} open={open} /> : (
                <DialogContent>
                    <DialogContentText>{t('meeting.sip.notPermission', { ns: NS_TRANS.MAIN })}</DialogContentText>
                </DialogContent>
            )}
        </DialogBaseCC>
    )
}

export default DialogJoinMeetingCC
